/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_Updated_RecentlyInputs */

const en_cmdk_updated_recently = /** @type {(inputs: Cmdk_Updated_RecentlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated recently`)
};

const es_cmdk_updated_recently = /** @type {(inputs: Cmdk_Updated_RecentlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado recientemente`)
};

/**
* | output |
* | --- |
* | "Updated recently" |
*
* @param {Cmdk_Updated_RecentlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_updated_recently = /** @type {((inputs?: Cmdk_Updated_RecentlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_Updated_RecentlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_updated_recently(inputs)
	return en_cmdk_updated_recently(inputs)
});